import { render, staticRenderFns } from "./TreatmentAreaByNurse.vue?vue&type=template&id=13a88f3e&"
import script from "./TreatmentAreaByNurse.vue?vue&type=script&lang=js&"
export * from "./TreatmentAreaByNurse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports